<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.7109 16.2222C19.1627 16.2222 21.9609 13.4862 21.9609 10.1111C21.9609 6.73604 19.1627 4 15.7109 4C12.2592 4 9.46094 6.73604 9.46094 10.1111C9.46094 13.4862 12.2592 16.2222 15.7109 16.2222ZM15.7109 16.2222C18.3631 16.2222 20.9066 17.2524 22.782 19.0861C24.6574 20.9198 25.7109 23.4068 25.7109 26H5.71094C5.71094 23.4068 6.76451 20.9198 8.63987 19.0861C10.5152 17.2524 13.0588 16.2222 15.7109 16.2222Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script setup></script>
